import {isDevMode, NgModuleRef, StaticProvider} from '@angular/core';
import {downgradeModule, setAngularJSGlobal} from '@angular/upgrade/static';
import * as angular from 'angular';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {WebHovedmodulNg2} from "./web-hoved-modul-ng2";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {byggmiljøNg2} from "web-ng2/miljø/miljø";

const debug = initDebugger('bootstrapNg2');

/**
 * Registrerer vår ng2-modul ( {@link WebHovedmodulNg2} ) i ng
 * og returnerer ng-modulnavnet som kan benyttes i kall til angular.module(...)
 * ifbm reg av nedgraderte ng2 komponenter og tjenester.
 *
 * Merk at pga bruk av downgradeModule(..) for ajs-ng2 integrasjon vil ikke ng2 lastes før
 * FØRSTE ng2-komponent instansieres, dette er en utfordring i de tilfeller der man har bruk for
 * å injisere ng2-tjenester i ajs-kode.
 * Se i src/scripts/web/nedgraderteNg2Tjenester.ts for hvordan dette er håndtert.
 */
export function ng2ModulSomNedgradert(): string {
    return downgradeModule(bootstrapNg2);
}

function bootstrapNg2(extraProviders: StaticProvider[]): Promise<NgModuleRef<WebHovedmodulNg2>> {
    debug(`NG2 bootstrappes, byggmiljøNg2.production: ${byggmiljøNg2.production} (isDevMode: ${isDevMode()})`);
    setAngularJSGlobal(angular);

    return platformBrowserDynamic(extraProviders)
      .bootstrapModule(WebHovedmodulNg2)
    // .catch(err => console.log(err));
}
